import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        // Sélectionner l'élément sur lequel vous souhaitez ajouter le gestionnaire d'événements
        const messengerElement = this.el;

        // Ajouter un gestionnaire d'événements click à cet élément
        messengerElement.addEventListener('click', function() {
            // Sélectionner l'élément hôte du shadow root
            const shadowHost = document.querySelector('#lpdg-texto'); // Remplacez par le sélecteur approprié pour l'élément hôte du shadow root
            if (shadowHost && shadowHost.shadowRoot) {
                // Sélectionner le bouton avec l'ID #trigger dans le shadow root
                const triggerButton = shadowHost.shadowRoot.querySelector('#trigger');
                if (triggerButton) {
                    // Émuler un clic sur le bouton
                    triggerButton.click();
                    // console.log('trigger found');

                    // Ajouter la classe .-is-single-active à shadowHost
                    shadowHost.classList.add('-is-single-active');
                } else {
                    // console.error('Button with ID #trigger not found in shadow root');
                }
            } else {
                // console.error('Shadow host or shadow root not found');
            }
        });

        // Vérifier si l'élément existe au chargement de la page après un délai
        setTimeout(() => {
            const shadowHost = document.querySelector('#lpdg-texto'); // Remplacez par le sélecteur approprié pour l'élément hôte du shadow root
            if (shadowHost && shadowHost.shadowRoot) {
                // Sélectionner l'élément .c-custom-texto-trigger__wrapper dans le shadow root
                const customTextoTriggerWrapper = shadowHost.shadowRoot.querySelector('.c-custom-texto-trigger__wrapper');
                if (customTextoTriggerWrapper) {
                    // Ajouter style="display:none;" à l'élément
                    customTextoTriggerWrapper.style.display = 'none';
                    // console.log('.c-custom-texto-trigger__wrapper found and hidden');
                } else {
                    // console.error('.c-custom-texto-trigger__wrapper not found in shadow root');
                }
            } else {
                // console.error('Shadow host or shadow root not found');
            }
        }, 500); // Délai de 1000 ms (1 seconde)

    }
}